import React from 'react';
import { Container, Row, Col } from 'reactstrap';

import logo_clinica_del_ginocchio from "../assets/img/logo_clinica_del_ginocchio.png";
import logo_telephysio from "../assets/img/logo_telephysio.png";
import { RoundButtonSecondary } from "./buttons";

import 'bootstrap/dist/css/bootstrap.min.css';
import '../assets/App.css';


const Services = () => {
    return (
        <div className='elem-content-container'>
            <section id='specializations' style={{paddingTop: 128, paddingBottom: 64}}>
                <Container>
                    <Row>
                        <Col lg='12' className="text-center">
                            <h2 className="section-heading text-primary mb-5">I miei Servizi</h2>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg='6' className="text-center mb-4">
                            <div className="mx-auto">
                                <img src={logo_clinica_del_ginocchio} alt="Clinica del ginocchio"/>
                            </div>
                            <div className="service-box mx-auto">
                                <p className="mb-3 text-spec-claim">
                                Trauma al ginocchio? Ti trascini da tempo un dolore? Sei stato appena operato? 
                                </p>
                                <p className="text-muted mb-0">
                                A Vimercate, un servizio dedicato a soggetti che soffrono di problematiche del ginocchio, 
                                che siano post-infortunio, post-chirurgia o dolori persistenti. 
                                Un’attenta valutazione funzionale consentirà di impostare un percorso riabilitativo con obiettivi personalizzati...
                                <br/>
                                <br/>
                                <span className="text-spec-claim">Per tornare  a muoverti libero dal dolore o a praticare il tuo sport preferito!</span>
                                </p>
                            </div>
                            <div className="my-4">
                                <RoundButtonSecondary href='https://www.qifisio.it/clinica-del-ginocchio/' text='Pronto ad iniziare?' />
                            </div>
                        </Col>
                        <Col lg='6' className="text-center  mb-4">
                            <div className="mx-auto">
                                <img src={logo_telephysio} alt="telephysio, riabilitazione online"/>
                            </div>
                            <div className="service-box mx-auto">
                                <p className="mb-3 text-spec-claim">
                                Lo sapevi che per fare fisioterapia c'è un modo semplice, efficace e... da casa? 
                                </p>
                                <p className="text-muted mb-0">
                                Un percorso riabilitativo a distanza tramite video-sedute e una piattaforma online 
                                dove poter seguire le video descrizioni degli esercizi assegnati.
                                Spesso, l’arma vincente per risolvere un problema è l'educazione alla sua gestione e la costanza nell'esercizio...
                                <br/>
                                <br/>
                                <span className="text-spec-claim">Tutto efficacemente e facilmente gestibile con sedute a distanza!</span>
                                </p>
                            </div>
                            <div className="my-4">
                                <RoundButtonSecondary to='/contacts/' text='Scopri se fa per te!' />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </div>
    );
};


export default Services;
